import {
  createRouter,
  createWebHashHistory
} from 'vue-router'
import Home from '../views/Home.vue'

function validaConexao(next) {
  if (!window.navigator.onLine) {
    return next({
      path: '/offline'
    });
  }
  return next();
}

const routes = [{
    path: '/',
    name: 'home',
    component: Home,
    beforeEnter: (to, from, next) => {
      validaConexao(next);
      next()
    }
  },
  {
    path: '/vuemask',
    name: 'VueMask',
    component: () => import('../views/VueMask.vue'),
    beforeEnter: (to, from, next) => {
      validaConexao(next);
      next()
    }
  },
  {
    path: '/login',
    name: 'login',
    component: function () {
      return import( /* webpackChunkName: "login" */ '../views/Login.vue')
    }
  },
  {
    path: '/adesaomaioridade',
    name: 'AdesaoMaiorIdade',
    component: () => import('../views/MaiorDeIdade.vue'),
    beforeEnter: (to, from, next) => {
      validaConexao(next);
      next()
    }
  },
  {
    path: '/adesaomenoridade',
    name: 'AdesaoMenorIdade',
    component: () => import('../views/MenorDeIdade.vue'),
    beforeEnter: (to, from, next) => {
      validaConexao(next);
      next()
    }
  },
  {
    path: '/avisovalidacao',
    name: 'AvisoValidacao',
    component: () => import('../views/AvisoValidacao.vue'),
    beforeEnter: (to, from, next) => {
      validaConexao(next);
      next()
    }
  },
  {
    path: '/beneficiosolicitado',
    name: 'BeneficioSolicitado',
    component: () => import('../views/BeneficioSolicitado.vue'),
    beforeEnter: (to, from, next) => {
      validaConexao(next);
      next()
    }
  },
  {
    path: '/cadastro',
    name: 'Cadastro',
    component: () => import('../views/CadastroGeral.vue'),
    beforeEnter: (to, from, next) => {
      validaConexao(next);
      next()
    }
  },
  {
    path: '/consultoria',
    name: 'Consultoria',
    component: () => import('../views/ConsultoriaAgendamento.vue'),
    beforeEnter: (to, from, next) => {
      validaConexao(next);
      next()
    }
  },

  {
    path: '/cadastroincompleto',
    name: 'CadastroIncompleto',
    component: () => import('../views/CadastroIncompleto.vue'),
    beforeEnter: (to, from, next) => {
      validaConexao(next);
      next()
    }
  },
  {
    path: '/campanhatrocaperfil',
    name: 'CampanhaTrocaPerfil',
    component: () => import('../views/CampanhaTrocaPerfil.vue'),
    beforeEnter: (to, from, next) => {
      validaConexao(next);
      next()
    }
  },
  {
    path: '/confirmacaodadosfinal',
    name: 'ConfirmacaoDadosFinal',
    component: () => import('../views/ConfirmacaoDadosFinal.vue'),
    beforeEnter: (to, from, next) => {
      validaConexao(next);
      next()
    }
  },
  {
    path: '/confirmarcpf',
    name: 'ConfirmarCpf',
    component: () => import('../views/ConfirmarCPF.vue'),
    beforeEnter: (to, from, next) => {
      validaConexao(next);
      next()
    }
  },
  {
    path: '/documentos',
    name: 'Documentos',
    component: () => import('../views/Documentos.vue'),
    beforeEnter: (to, from, next) => {
      validaConexao(next);
      next()
    }
  },
  {
    path: '/emprestimo',
    name: 'Emprestimo',
    component: () => import('../views/SimuladorEmprestimo.vue'),
    beforeEnter: (to, from, next) => {
      validaConexao(next);
      next()
    }
  },
  {
    path: '/esqueciminhasenha',
    name: 'EsqueciMinhaSenha',
    component: () => import('../views/EsqueciMinhaSenha.vue'),
    beforeEnter: (to, from, next) => {
      validaConexao(next);
      next()
    }
  },
  {
    path: '/erroconfirmacaodados',
    name: 'ErroConfirmacaoDados',
    component: () => import('../views/ErroConfirmacaoDados.vue'),
    beforeEnter: (to, from, next) => {
      validaConexao(next);
      next()
    }
  },
  {
    path: '/errologin',
    name: 'ErroLogin',
    component: () => import('../views/ErroLogin.vue'),
    beforeEnter: (to, from, next) => {
      validaConexao(next);
      next()
    }
  },
  {
    path: '/escolher',
    name: 'Escolher',
    component: () => import('../views/Escolher.vue'),
    beforeEnter: (to, from, next) => {
      validaConexao(next);
      next()
    }
  },
  {
    path: '/extratoinvestimento',
    name: 'ExtratoInvestimento',
    component: () => import('../views/ExtratoInvestimento.vue'),
    beforeEnter: (to, from, next) => {
      validaConexao(next);
      next()
    }
  },
  {
    path: '/extratoirrf',
    name: 'ExtratoIrrf',
    component: () => import('../views/ExtratoIRRF.vue'),
    beforeEnter: (to, from, next) => {
      validaConexao(next);
      next()
    }
  },
  {
    path: '/historicocontribuicao',
    name: 'HistoricoContribuicao',
    component: () => import('../views/HistoricoContribuicao.vue'),
    beforeEnter: (to, from, next) => {
      validaConexao(next);
      next()
    }
  },
  {
    path: '/historicoemprestimo',
    name: 'HistoricoEmprestimo',
    component: () => import('../views/HistoricoEmprestimo.vue'),
    beforeEnter: (to, from, next) => {
      validaConexao(next);
      next()
    }
  },
  {
    path: '/historicorecebimento',
    name: 'HistoricoRecebimento',
    component: () => import('../views/HistoricoRecebimento.vue'),
    beforeEnter: (to, from, next) => {
      validaConexao(next);
      next()
    }
  },
  // {
  //   path: '/icons',
  //   name: 'Icons',
  //   component: () => import('../views/Icons.vue'),
  //   beforeEnter: (to, from, next) => {
  //     validaConexao(next);
  //     next()
  //   }
  // },
  {
    path: '/maisamigos',
    name: 'Mais Amigos',
    component: () => import('../views/MaisAmigos.vue'),
    beforeEnter: (to, from, next) => {
      validaConexao(next);
      next()
    }
  },
  {
    path: '/minhasduvidas',
    name: 'Minhas Duvidas',
    component: () => import('../views/MinhasDuvidas.vue')
  },
  {
    path: '/offline',
    name: 'Offline',
    component: () => import('../views/Offline.vue')
  },
  {
    path: '/outrassolicitacoes',
    name: 'OutrasSolicitacoes',
    component: () => import('../views/OutrasSolicitacoes.vue'),
    beforeEnter: (to, from, next) => {
      validaConexao(next);
      next()
    }
  },
  {
    path: '/pagamento',
    name: 'Pagamento',
    component: () => import('../views/Pagamento.vue'),
    beforeEnter: (to, from, next) => {
      validaConexao(next);
      next()
    }
  },
  {
    path: '/pesquisaperfilbeneficio',
    name: 'PesquisaPerfilBeneficio',
    component: () => import('../views/PesquisaPerfilBeneficio.vue'),
    beforeEnter: (to, from, next) => {
      validaConexao(next);
      next()
    }
  },
  {
    path: '/planoencerrado',
    name: 'PlanoEncerrado',
    component: () => import('../views/PlanoEncerrado.vue'),
    beforeEnter: (to, from, next) => {
      validaConexao(next);
      next()
    }
  },
  {
    path: '/previdenciaprivada',
    name: 'PrevidenciaPrivada',
    component: () => import('../views/PrevidenciaPrivada.vue'),
    beforeEnter: (to, from, next) => {
      validaConexao(next);
      next()
    }
  },
  {
    path: '/primeirologin',
    name: 'PrimeiroLogin',
    component: () => import('../views/PrimeiroLogin.vue'),
    beforeEnter: (to, from, next) => {
      validaConexao(next);
      next()
    }
  },
  {
    path: '/primeirologinconfirmacao',
    name: 'PrimeiroLoginConfirmacao',
    component: () => import('../views/PrimeiroLoginConfirmacao.vue'),
    beforeEnter: (to, from, next) => {
      validaConexao(next);
      next()
    }
  },
  {
    path: '/meuextrato',
    name: 'MeuExtrato',
    component: () => import('../views/MeuExtrato.vue'),
    beforeEnter: (to, from, next) => {
      validaConexao(next);
      next()
    }
  },
  {
    path: '/renda',
    name: 'Renda',
    component: () => import('../views/SimuladorRenda.vue'),
    beforeEnter: (to, from, next) => {
      validaConexao(next);
      next()
    }
  },
  {
    path: '/rentabilidade',
    name: 'Rentabilidade',
    component: () => import('../views/Rentabilidade.vue'),
    beforeEnter: (to, from, next) => {
      validaConexao(next);
      next()
    }
  },
  {
    path: '/resgategeralead',
    name: 'ResgateGeraLead',
    component: () => import('../views/ResgateGeraLead.vue'),
    beforeEnter: (to, from, next) => {
      validaConexao(next);
      next()
    }
  },
  {
    path: '/resgateparcial',
    name: 'ResgateParcial',
    component: () => import('../views/ResgateParcial.vue'),
    beforeEnter: (to, from, next) => {
      validaConexao(next);
      next()
    }
  },
  {
    path: '/resgatesolicitacao',
    name: 'ResgateSolicitacao',
    component: () => import('../views/ResgateSolicitacao.vue'),
    beforeEnter: (to, from, next) => {
      validaConexao(next);
      next()
    }
  },
  {
    path: '/resgatetotal',
    name: 'ResgateTotal',
    component: () => import('../views/ResgateTotal.vue'),
    beforeEnter: (to, from, next) => {
      validaConexao(next);
      next()
    }
  },
  {
    path: '/resgatesolicitado',
    name: 'ResgateSolicitado',
    component: () => import('../views/ResgateSolicitado.vue'),
    beforeEnter: (to, from, next) => {
      validaConexao(next);
      next()
    }
  },
  {
    path: '/seguro',
    name: 'Seguro',
    component: () => import('../views/SimuladorSeguro.vue'),
    beforeEnter: (to, from, next) => {
      validaConexao(next);
      next()
    }
  },
  {
    path: '/servicos',
    name: 'Servicos',
    component: () => import('../views/Servicos.vue'),
    beforeEnter: (to, from, next) => {
      validaConexao(next);
      next()
    }
  },
  {
    path: '/simuladoraporte',
    name: 'SimuladorAporte',
    component: () => import('../views/SimuladorAporte.vue'),
    beforeEnter: (to, from, next) => {
      validaConexao(next);
      next()
    }
  },
  {
    path: '/simuladorbeneficio',
    name: 'SimuladorBeneficio',
    component: () => import('../views/SimuladorBeneficio.vue'),
    beforeEnter: (to, from, next) => {
      validaConexao(next);
      next()
    }
  },
  {
    path: '/simuladorbeneficioavancado',
    name: 'SimuladorBeneficioAvancado',
    component: () => import('../views/SimuladorBeneficioAvancado.vue'),
    beforeEnter: (to, from, next) => {
      validaConexao(next);
      next()
    }
  },
  {
    path: '/simuladorbeneficiofinalizado',
    name: 'SimuladorBeneficioFinalizado',
    component: () => import('../views/SimuladorBeneficioFinalizado.vue'),
    beforeEnter: (to, from, next) => {
      validaConexao(next);
      next()
    }
  },
  {
    path: '/simuladorbeneficiofiscal',
    name: 'SimuladorBeneficioFiscal',
    component: () => import('../views/SimuladorBeneficioFiscal.vue'),
    beforeEnter: (to, from, next) => {
      validaConexao(next);
      next()
    }
  },
  {
    path: '/simuladorbeneficiosimplificado',
    name: 'SimuladorBeneficioSimplificado',
    component: () => import('../views/SimuladorBeneficioSimplificado.vue'),
    beforeEnter: (to, from, next) => {
      validaConexao(next);
      next()
    }
  },
  {
    path: '/simuladorbeneficiowizard',
    name: 'SimuladorBeneficioWizard',
    component: () => import('../views/SimuladorBeneficioWizard.vue'),
    beforeEnter: (to, from, next) => {
      validaConexao(next);
      next()
    }
  },
  {
    path: '/sobreapp',
    name: 'SobreApp',
    component: () => import('../views/SobreApp.vue'),
    beforeEnter: (to, from, next) => {
      validaConexao(next);
      next()
    }
  },
  {
    path: '/todosvideos',
    name: 'TodosVideos',
    component: () => import('../views/VideosTodos.vue'),
    beforeEnter: (to, from, next) => {
      validaConexao(next);
      next()
    }
  },

  {
    path: '/universidade',
    name: 'Universidade',
    component: () => import('../views/Universidade.vue'),
    beforeEnter: (to, from, next) => {
      validaConexao(next);
      next()
    }
  },
  {
    path: '/videos',
    name: 'Videos',
    component: () => import('../views/VideosMaisFuturo.vue'),
    beforeEnter: (to, from, next) => {
      validaConexao(next);
      next()
    }
  },
  {
    path: '/vitrine',
    name: 'Vitrine',
    component: () => import('../views/Vitrine.vue'),
    beforeEnter: (to, from, next) => {
      validaConexao(next);
      next()
    }
  },
  {
    path: '/vitrineparceiros',
    name: 'VitrineParceiros',
    component: () => import('../views/VitrineParceiros.vue'),
    beforeEnter: (to, from, next) => {
      validaConexao(next);
      next()
    }
  },
  {
    path: '/vitrineprodutosparceiros',
    name: 'VitrineProdutosParceiros',
    component: () => import('../views/VitrineProdutosParceiros.vue'),
    beforeEnter: (to, from, next) => {
      validaConexao(next);
      next()
    }
  },
  {
    path: '/vitrineshowproduto',
    name: 'VitrineShowProduto',
    component: () => import('../views/VitrineShowProduto.vue'),
    beforeEnter: (to, from, next) => {
      validaConexao(next);
      next()
    }
  },
  {
    path: '/trocaparticipacao',
    name: 'TrocaParticipacao',
    component: () => import('../views/TrocaParticipacao.vue'),
    beforeEnter: (to, from, next) => {
      validaConexao(next);
      next()
    }
  },
  {
    path: '/alertacustom',
    name: 'alertacustom',
    component: () => import('../views/CustomAlert.vue'),
    beforeEnter: (to, from, next) => {
      validaConexao(next);
      next()
    }
  },
  {
    path: '/instalacao',
    name: 'instalacao',
    component: () => import('../views/Instalacao.vue'),
    beforeEnter: (to, from, next) => {
      validaConexao(next);
      next()
    }
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})



export default router